import React from "react";
import { observer } from "mobx-react";
import { UploadedContentSessionTemplate } from "themes/administration/uploaded-content/pages";
import { UploadedContentSessionViewStore } from "administration/uploaded-content/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new UploadedContentSessionViewStore(rootStore, componentProps),
    "uploadedContentSessionViewStore"
)
@observer
class UploadedContentSessionPage extends React.Component {
    render() {
        return <UploadedContentSessionTemplate {...this.props} />;
    }
}

export default UploadedContentSessionPage;
